import {createSlice} from '@reduxjs/toolkit';
import {CaregiverDetailsDto} from 'src/shared/services/caregivers/dto/caregiver-details-dto';

interface CaregiversInitialState {
  caregiversList: Array<CaregiverDetailsDto> | undefined;
  caregiverDetails: CaregiverDetailsDto | undefined;
  isCaregiversListLoading: boolean | undefined;
}

const initialState: CaregiversInitialState = {
  caregiversList: [],
  caregiverDetails: undefined,
  isCaregiversListLoading: false,
};

const caregiversSlice = createSlice({
  name: 'caregivers',
  initialState: initialState,
  reducers: {
    setCaregiversList: (state, action) => {
      state.caregiversList = action.payload;
    },
    setCaregiverDetails: (state, action) => {
      state.caregiverDetails = action.payload;
    },
    setIsCaregiversListLoading: (state, action) => {
      state.isCaregiversListLoading = action.payload;
    },
  },
});

export const {
  setCaregiversList,
  setCaregiverDetails,
  setIsCaregiversListLoading,
} = caregiversSlice.actions;

export default caregiversSlice.reducer;
